import { createContext, useContext, ReactNode, useState } from "react";
import useWidthTracker from "../hooks/mobileVersionMonitor";

const MobileVersionContext = createContext<MobileMode>({
  isMobile: true,
});

export const MobileVersionProvider = ({
  children,
}: {
  children: ReactNode;
}) => {
  const [isMobile, setMobile] = useState(false);

  useWidthTracker(setMobile);

  return (
    <MobileVersionContext.Provider value={{ isMobile }}>
      {children}
    </MobileVersionContext.Provider>
  );
};

export const useMobileVersion = () => useContext(MobileVersionContext);
